const scheduleBasicsTour = {
  id: 'schedule-basics',
  title: 'Schedule basics',
  summary: 'Find your way around the schedule sheet.',
  // Only an open schedule sheet has these targets; the list page has none.
  match: '/dashboard/yawn/schedule/,!/dashboard/yawn/schedule/list,!/dashboard/yawn/schedule/new',
  autoStart: true,
  version: 1,
  steps: [
    {
      target: 'sheet-nav-pane',
      title: 'Navigate by category',
      body: 'Jump to any section — click "CLD – Cladding" to go to cladding. Expand an item to drill into its subcategories and line items.',
      placement: 'right',
      optional: true,
    },
    {
      target: 'sheet-nav-collapse',
      title: 'Collapse the navigation',
      body: 'Toggle the arrow to widen your schedule when you need the space.',
      placement: 'right',
      optional: true,
    },
    {
      target: 'sheet-column-header',
      title: 'Resize your columns',
      body: 'Drag the edge of any column header to set the width that suits your screen.',
      tip: 'Start typing in a column header to filter rows by that column.',
      placement: 'bottom',
      optional: true,
    },
    {
      target: 'sheet-row-drag',
      title: 'Reorder rows',
      body: 'Drag a row handle up or down to move it.',
      placement: 'right',
      optional: true,
    },
    {
      target: 'sheet-row-menu',
      title: 'The row menu',
      body: 'Add a row below, copy, cut, paste, delete — and use Indent and Outdent to change its heading level.',
      tip: '"Library" imports items from your previous projects.',
      placement: 'right',
      optional: true,
    },
    {
      target: 'sheet-checkbox-col',
      title: 'Select what is in',
      body: 'Tick a row checkbox to include that item in your schedule.',
      tip: 'Click the checkbox in the header to filter: tick = selected only, dash = everything, blank = unselected only.',
      placement: 'bottom',
      optional: true,
    },
    {
      target: 'sheet-product-pick',
      title: 'Add a product',
      body: 'Open the product catalogue to browse by manufacturer, with images, summaries and certifications. Preview an item, then add it to your row.',
      tip: 'Every line item has a template description you can tailor if your product is not listed yet.',
      placement: 'left',
      optional: true,
    },
    {
      target: 'sheet-menu-bar',
      title: 'Your toolbar',
      body: 'Batch, Export, Import, Find, Settings, Revisions, Comments and more — all live up here.',
      tip: 'Take the "Products and codes" or "Collaboration" tour from Help to go deeper.',
      placement: 'bottom',
    },
  ],
};

export default scheduleBasicsTour;
